import { atom, selector } from "recoil"
import { draftSelector } from "src/recoil/selectors/contact/draftSelector"
import { templateSelector } from "src/recoil/selectors/contact/templateSelector"
import { existingContactDetailSelector } from "src/recoil/selectors/contact/create/existingContactDetailSelector"
import { reservedSelector } from "src/recoil/selectors/contact/reservedSelector"

const initialState = undefined

const initialStateSelector = selector<boolean | undefined>({
  key: "atoms/contact/create/isReceiversAllMembersState_initialState",
  get: ({ get }) => {
    const contact = get(existingContactDetailSelector)
    const contactValue = contact?.receivers.isAllMembers
    const reserved = get(reservedSelector)
    const reservedValue = reserved?.receivers.isAllMembers
    const template = get(templateSelector)
    const draft = get(draftSelector)
    return contactValue ?? reservedValue ?? (template ?? draft)?.isReceiversAllMembers ?? initialState
  },
})

export const isReceiversAllMembersState = atom<boolean | undefined>({
  key: "atoms/contact/create/isReceiversAllMembersState",
  default: initialStateSelector,
})
